import { get, isEmpty } from 'lodash';

import { Colors } from 'components/utils/styles/ui';

// Keep these branding tokens in sync with the BE mirror @default_list_settings
// (shared_list/themes/theme.ex) — drift breaks byte-identical-when-unthemed.
const DefaultSettings = {
  list_settings: {
    button_primary_color: Colors.tealDark,
    button_primary_outline_color: Colors.tealDark,
    button_primary_text_color: Colors.white,
    button_secondary_color: Colors.tealLighter,
    button_secondary_outline_color: Colors.outline,
    button_secondary_text_color: Colors.text,
    list_accent: Colors.tealDark,
    list_accent_dark: Colors.tealDarker,
    list_accent_tint: Colors.tealLightest,
    list_text: Colors.text,
    list_text_secondary: Colors.textLight,
    list_text_muted: Colors.textLighter,
    list_surface: Colors.white,
    list_border: Colors.outline,
    list_counter_bg: Colors.red,
    list_counter_text: Colors.white,
    list_radius: '0.8rem',
    list_card_radius: '0.8rem',
    list_button_radius: '0.2rem',
  },
  candidate_header_image: null,
  candidate_footer_image: null,
  candidate_settings: {
    layout: 'cards',
    candidate_avatar: 'no',
    company_logo: 'yes',
    field_icon: 'yes',
    experience_field_icon: 'yes',
    text_color: Colors.text,
    primary_name_color: Colors.tealDark,
    secondary_name_color: Colors.textLight,
    section_name_color: Colors.text,
    experience_field_title_color: Colors.text,
    field_title_color: Colors.textLight,
    bulletpoint_color: Colors.text,
    highlight_color: Colors.tealLight,
    section_divider_color: Colors.outline,
    experience_field_subtitle_divider_color: Colors.outline,
    label_background_color: Colors.tealLightest,
    label_border_color: Colors.outline,
    label_text_color: Colors.text,
    field_icon_color: Colors.textLight,
    field_icon_background_color: Colors.labelBg,
    experience_field_icon_color: Colors.white,
    experience_field_icon_background_color: Colors.tealDarker,
    start_end_date_format: 'shortened',
    show_duration: 'yes',
  },
};

export const getThemeSetting = (theme, setting, fallback = true) =>
  get(theme || (fallback ? DefaultSettings : null), setting);

export const divergesFromDefaultToken = (theme, key) => {
  const setting = `list_settings.${key}`;
  const value = getThemeSetting(theme, setting, false);
  const defaultValue = getThemeSetting(null, setting);

  return value == null || value === defaultValue ? undefined : value;
};

export const showAsset = (theme, setting, asset) => {
  const value = getThemeSetting(theme, setting);

  return value === 'yes' || (value === 'uploaded' && !isEmpty(asset));
};
